
export const DIGITAL = 'DIGITAL'
export const PEN= 'PEN'
export const NONE= 'NONE'